import * as React from "react";
import { transition, useStateTransition, match } from "../";
import { colors } from "./styles";
const reducer = (prevState, action) => transition(prevState, action, {
    IDLE: {
        ON_MOUSE_DOWN: (_, { x }) => ({
            state: "DETECTING_RESIZE",
            initialX: x,
        }),
    },
    DETECTING_RESIZE: {
        ON_MOUSE_MOVE: (state, { x }) => {
            if (Math.abs(x - state.initialX) > 3) {
                return {
                    state: "RESIZING",
                    x,
                };
            }
            return state;
        },
        ON_MOUSE_UP: () => ({
            state: "IDLE",
        }),
        ON_MOUSE_UP_RESIZER: () => ({
            state: "IDLE",
        }),
    },
    RESIZING: {
        ON_MOUSE_MOVE: (_, { x }) => ({
            state: "RESIZING",
            x,
        }),
        ON_MOUSE_UP: () => ({
            state: "IDLE",
        }),
    },
});
export const Resizer = ({ onResize, onClick, isOpen, }) => {
    const [resizer, dispatch] = React.useReducer(reducer, {
        state: "IDLE",
    });
    useStateTransition(resizer, ["DETECTING_RESIZE", "RESIZING"], () => {
        const onMouseMoveListener = (event) => dispatch({ type: "ON_MOUSE_MOVE", x: event.clientX });
        const onMouseUpListener = (event) => dispatch({ type: "ON_MOUSE_UP", x: event.clientX });
        window.addEventListener("mousemove", onMouseMoveListener);
        window.addEventListener("mouseup", onMouseUpListener);
        return () => {
            window.removeEventListener("mousemove", onMouseMoveListener);
            window.removeEventListener("mouseup", onMouseUpListener);
        };
    });
    useStateTransition(resizer, {
        DETECTING_RESIZE: {
            ON_MOUSE_MOVE: "DETECTING_RESIZE",
        },
        RESIZING: {
            ON_MOUSE_MOVE: "RESIZING",
        },
    }, (_, { x }, __) => {
        onResize(window.innerWidth - x);
    });
    useStateTransition(resizer, {
        DETECTING_RESIZE: {
            ON_MOUSE_UP_RESIZER: "IDLE",
        },
    }, () => onClick());
    const style = {
        position: "absolute",
        height: "100%",
        width: "10px",
        backgroundColor: colors.blue,
        userSelect: "none",
        zIndex: 99999999,
    };
    return match(resizer, {
        IDLE: () => (React.createElement("div", { style: style, onMouseDown: (event) => dispatch({ type: "ON_MOUSE_DOWN", x: event.clientX }) })),
        DETECTING_RESIZE: () => (React.createElement("div", { style: style, onMouseUp: () => dispatch({ type: "ON_MOUSE_UP_RESIZER" }) })),
        RESIZING: () => React.createElement("div", { style: style }),
    });
};
//# sourceMappingURL=Resizer.js.map